import { Component, Input, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ActionsService } from "../../../components/actions/actions.service";

@Component({
  standalone: true,
  selector: "app-node-icon",
  imports: [CommonModule],
  templateUrl: "./node-icon.component.html",
  styleUrls: ["./node-icon.component.scss"],
})
export class NodeIconComponent implements OnInit {
  @Input() nodeData: any;
  @Input() workflowName = "";
  zuperNodeData = {
    isZuperIcon: false,
    iconColor: "#FFEFE7",
    backgroundColor: "#ff9869",
    borderColor: "#ffc7ad",
  };

  constructor(private actionsService: ActionsService) { }
  private zuper_node_names = [
    "zuper",
    this.actionsService.zuperCreateNodeData.node_name,
    this.actionsService.zuperUpdateNodeData.node_name,
    this.actionsService.zuperCustomFieldCopyData.node_name,
    this.actionsService.zuperGetNodeData.node_name,
  ];

  ngOnInit() {
    if (
      this.nodeData?.node_name?.toLowerCase()?.includes("zuper") &&
      (["TRIGGER"].includes(this.nodeData?.action_type) ||
        this.zuper_node_names.includes(this.nodeData?.node_name))
    ) {
      this.zuperNodeData.isZuperIcon = true;
      if (
        !["TRIGGER"].includes(this.nodeData?.action_type) &&
        this.zuper_node_names.some((e) => e === this.nodeData?.node_name)
      ) {
        this.zuperNodeData.iconColor = this?.nodeData?.color?.main || "#4682B4";
        this.zuperNodeData.backgroundColor =
          this?.nodeData?.color?.iconBackground || "#ffffff";
        this.zuperNodeData.borderColor =
          this?.nodeData?.color?.borderColor ||
          this.nodeData?.color?.main ||
          "#cbd3e3";
      }
    } else {
      this.zuperNodeData.iconColor = this.nodeData?.color?.main || "#cbd3e3";
      this.zuperNodeData.backgroundColor =
        this.nodeData?.color?.iconBackground || "#ffffff";
      this.zuperNodeData.borderColor =
        this.nodeData?.color?.borderColor ||
        this.nodeData?.color?.main ||
        "#cbd3e3";
    }
  }
}
